import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Container } from '@mui/material';
import {AlertList} from '../sections/@dashboard/alert';

export default function AlertPage() {
  return (
    <>
      <Helmet>
        <title>Alert | WatchNod</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>

      <Container maxWidth="xl">
        <AlertList />
      </Container>
    </>
  );
}
